import { render, staticRenderFns } from "./RightModal.vue?vue&type=template&id=96ce773e&scoped=true&"
import script from "./RightModal.vue?vue&type=script&lang=js&"
export * from "./RightModal.vue?vue&type=script&lang=js&"
import style0 from "./RightModal.vue?vue&type=style&index=0&id=96ce773e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ce773e",
  null
  
)

export default component.exports